export default __webpack_public_path__ + "static/media/grama-esportiva3.5b679ebf.jpg";